<section class="settings-shell">
  <app-page-header
    title="Configuración"
    subtitle="Preferencias del módulo Vault y tu cuenta."
    icon="Settings"
  />

  <nav class="settings-shell__nav" aria-label="Secciones de configuración">
    <a
      class="settings-shell__link"
      routerLink="."
      routerLinkActive="settings-shell__link--active"
      [routerLinkActiveOptions]="{ exact: true }"
      >General</a
    >
    <a class="settings-shell__link" routerLink="profile" routerLinkActive="settings-shell__link--active"
      >Perfil y seguridad</a
    >
  </nav>

  <router-outlet />
</section>
